import { useEffect } from 'react';
import { useRouteMatch } from 'react-router-dom';
import { sendKameleoonVisitedPageEvent } from '../utils/kameleoon.utils';

export const useKameleoonVisitedPageEvent = () => {
  const router = useRouteMatch();
  useEffect(() => {
    sendKameleoonVisitedPageEvent(router.url);
  }, [router.url]);
};
